import { createReducer, on } from '@ngrx/store';
import { NotificationsState } from './models/notifications-state.interface';
import * as NotificationActions from './notifications.actions';

const notificationsInitState: NotificationsState = {
  notifications: [],
}

export const notificationsReducer = createReducer(
  notificationsInitState,
  on(NotificationActions.addNotification, (state, { notification }) => ({
    ...state,
    notifications: [
      notification,
      ...state.notifications,
    ],
  })),
  on(NotificationActions.removeNotification, (state, { createdAt }) => ({
    ...state,
    notifications: state.notifications.filter((error) => error.createdAt !== createdAt),
  })),
  on(NotificationActions.removeNotificationByErrorObject, (state, { errorObject }) => ({
    ...state,
    notifications: state.notifications.filter((error) => error.errorObject !== errorObject),
  })),
  on(NotificationActions.hideNotification, (state, { createdAt }) => ({
    ...state,
    notifications: state.notifications.map((error) =>
      error.createdAt === createdAt ? { ...error, hidden: true } : error,
    ),
  })),
  on(NotificationActions.toggleExpanded, (state, { id }) => ({
    ...state,
    notifications: state.notifications.map((error, index) =>
      index === id ? { ...error, expanded: !error.expanded } : error,
    ),
  })),
  on(NotificationActions.removeAllNotifications, (state) => ({
    ...state,
    notifications: [],
  })),
);
